// export default from './moment-enhanced';

import moment from './moment-enhanced.js'
export default moment
